import { FleekError } from './FleekError';

type GitLinkMultipleAccountErrorOptions = Record<string, never>;

export class GitLinkMultipleAccountError extends FleekError<GitLinkMultipleAccountErrorOptions> {
  public name = 'GitLinkMultipleAccountError';

  toString = () => `Oops! You already have a Git profile linked to your Fleek account. We don't allow multiple connections`;
}
